<template>
    <div class="ban-modal wrapper">
        <Modal2
            v-if="internalBanModalVisible"
            :show-footer="false"
            class="ban-modal"
            :title="$t('message.banModalTitle')"
            @cancel="closeModal"
        >
            <table class="ban-table">
                <thead>
                    <tr>
                        <th>{{ $t("message.platform") }}</th>
                        <th>{{ $t("chatbotv2.value") }}</th>
                        <th>{{ $t("message.sendingAllow") }}</th>
                        <th>{{ $t("message.receiving") }}</th>
                    </tr>
                </thead>
                <tr class="visitor-row">
                    <td>
                        <img
                            src="https://static.supsis.live/common/email/supsisyazisislogo.png"
                            class="ban-modal-icon supsis-logo"
                            :class="{ disable: !visitor._id }"
                        />
                    </td>
                    <td>
                        {{ visitor._id }}
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('web-visitor', 'outbound', $event)"
                            :checked="getVisitorSuppression('web-visitor', 'outbound')"
                            :disabled="!visitor._id"
                            @click="suppressionProcess('web-visitor', visitor._id)"
                        />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('web-visitor', 'inbound', $event)"
                            :checked="getVisitorSuppression('web-visitor', 'inbound')"
                            :disabled="!visitor._id"
                            @click="suppressionProcess('web-visitor', visitor._id)"
                        />
                    </td>
                </tr>
                <tr class="whatsapp-row">
                    <td>
                        <whatsappIcon
                            color="#25D366"
                            class="ban-modal-icon"
                            :class="{ disable: !visitor.whatsappNumber }"
                        />
                    </td>
                    <td>
                        {{ visitor.whatsappNumber || $t("visitor.noWpNumber") }}
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('whatsapp', 'outbound', $event)"
                            :checked="getVisitorSuppression('whatsapp', 'outbound')"
                            :disabled="!visitor.whatsappNumber"
                            @click="suppressionProcess('whatsapp', visitor.whatsappNumber)"
                        />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('whatsapp', 'inbound', $event)"
                            :checked="getVisitorSuppression('whatsapp', 'inbound')"
                            :disabled="!visitor.whatsappNumber"
                            @click="suppressionProcess('whatsapp', visitor.whatsappNumber)"
                        />
                    </td>
                </tr>
                <tr class="mail-row">
                    <td>
                        <gmail-icon class="ban-modal-icon" :class="{ disable: !visitor.email }" />
                    </td>
                    <td>
                        {{ visitor.email || $t("visitor.noEmail") }}
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('email', 'outbound', $event)"
                            :checked="getVisitorSuppression('email', 'outbound')"
                            :disabled="!visitor.email"
                            @click="suppressionProcess('email', visitor.email)"
                        />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2 switch"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('email', 'inbound', $event)"
                            :checked="getVisitorSuppression('email', 'inbound')"
                            :disabled="!visitor.email"
                            @click="suppressionProcess('email', visitor.email)"
                        />
                    </td>
                </tr>
                <tr class="ip-row">
                    <td>
                        <webIcon color="black" class="ban-modal-icon" :class="{ disable: !visitor.ipAddress }" />
                    </td>
                    <td>
                        {{ visitor.ipAddress || $t("visitor.noIpAddress") }}
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('web-visitor-ip', 'outbound', $event)"
                            :checked="getVisitorSuppression('web-visitor-ip', 'outbound')"
                            :disabled="!visitor.ipAddress"
                            @click="suppressionProcess('web-visitor-ip', visitor.ipAddress)"
                        />
                    </td>
                    <td>
                        <a-switch
                            class="ml-2 mr-2"
                            un-checked-children="✔"
                            checked-children="✖"
                            @change="setVisitorSuppression('web-visitor-ip', 'inbound', $event)"
                            :checked="getVisitorSuppression('web-visitor-ip', 'inbound')"
                            :disabled="!visitor.ipAddress"
                            @click="suppressionProcess('web-visitor-ip', visitor.ipAddress)"
                        />
                    </td>
                </tr>
            </table>
        </Modal2>
    </div>
</template>
<script>
import gmailIcon from "../views/Pages/Mail/icons/MailIcon.vue";
import whatsappIcon from "../views/Pages/Chatbot/pages/integrations/svg/WhatsappIcon.vue";
import webIcon from "../views/Pages/Visitors/components/svg/WebIcon.vue";
import Modal2 from "./common/Modal2.vue";
import { SUPPRESSION_API } from "../api/suppression";
import { mapState } from "vuex";
import { sendSocketMessage } from "../utils/socketStream";

export default {
    name: "VisitorBanModal",
    components: { Modal2, webIcon, whatsappIcon, gmailIcon },
    props: ["visitor", "banModalVisible"],
    data() {
        return {
            internalBanModalVisible: false,
            visitorSuppression: {},
        };
    },
    computed: {
        ...mapState({
            user: (state) => state.auth.user,
        }),
    },
    methods: {
        suppressionProcess(type, value) {
            if (!this.visitorSuppression[type]?.outbound && !this.visitorSuppression[type]?.inbound) {
                SUPPRESSION_API.remove(type, value);
            } else {
                SUPPRESSION_API.update(
                    type,
                    value,
                    !!this.visitorSuppression[type]?.inbound,
                    !!this.visitorSuppression[type]?.outbound,
                    this.user._id
                );
            }
            sendSocketMessage("visitor profile-updated", {
                siteId: this.visitor.siteId,
                visitorId: this.visitor._id,
            });
        },
        getVisitorSuppression(type, direction) {
            return !!this.visitorSuppression[type]?.[direction];
        },
        setVisitorSuppression(type, direction, value) {
            this.visitorSuppression = {
                ...this.visitorSuppression,
                [type]: {
                    ...(this.visitorSuppression[type] || {}),
                    [direction]: value,
                },
            };
        },
        closeModal() {
            this.internalBanModalVisible = false;
            this.$emit("close");
        },
    },
    async mounted() {
        if (this.visitor) {
            this.visitorSuppression = this.visitor.suppression || {};
            this.bannedList = await SUPPRESSION_API.list();
        }
    },
    watch: {
        banModalVisible: {
            immediate: true,
            handler(val) {
                this.internalBanModalVisible = val;
            },
        },
        visitor: {
            deep: true,
            handler() {
                if (!this.$_.isEqual(this.visitorSuppression, this.visitor.suppression || {})) {
                    this.visitorSuppression = this.visitor.suppression || {};
                }
            },
        },
        visitorSuppression: {
            deep: true,
            handler() {
                if (!this.$_.isEqual(this.visitorSuppression, this.visitor.suppression || {})) {
                    this.$emit("changed", this.visitorSuppression);
                }
            },
        },
    },
};
</script>
<style lang="scss" scoped>
.supsis-logo {
    width: 42px !important;
    height: 42px !important;
    object-fit: contain;
}
</style>
